import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const updatePlannedRouteActiveExcise = (
  value: MapState['routes']['activeExcise']
) => mapActions.setActiveExcise(value);
